module.exports = __webpack_public_path__ + "img/sqxx.bb982f48.png";